/** 800 milliseconds */
export const INITIAL_ANIMATION_DELAY = 0.8;

/** 1600 milliseconds */
export const LAST_ANIMATION_DELAY = INITIAL_ANIMATION_DELAY * 2;
